import api from './axios';

export const getSubscriptionStatus = async () => {
  const response = await api.get('/subscription/status');
  return response.data;
};

export const getSubscriptionPlans = async () => {
  const response = await api.get('/subscription/plans');
  return response.data;
};

export const checkAccess = async () => {
  const response = await api.get('/subscription/check-access');
  return response.data;
};
